import React, { useState } from 'react';
import './Tile.scss'
import { useTranslation } from 'react-i18next'

// import ff from "../../public/img/icons/customeditor/Favorite_icon_empty.png"


export interface TileProps {
    id: number,
    name: string,
    thumbnail: string,
    price: number,
    adjustedPrice: number,
    currency: string,
    description: string,
    specialPrice: string,
    pUrl: string,
    selectFabric: () => void
}


export const Tile = (props: TileProps) => {

    const { selectFabric, thumbnail, name, price, adjustedPrice, currency, description, specialPrice, pUrl } = props
    const {t} = useTranslation();

    return (
        <div className='selection-grid-tile' onClick={selectFabric}>
            <img className='tile-image' src={thumbnail} />
            <div className='tile-content'>
                <div>{name}</div>
                <div className='tile-content__price' data-nodiscount={specialPrice?.includes("<del") || false}>
                    <div dangerouslySetInnerHTML={{ __html: specialPrice }} />
                    {/* {price != adjustedPrice ? <div className='tile-content__price-mrp'>{`${price} ${currency}`}</div> : null}
                    <div className='tile-content__price-adjusted'>{`${adjustedPrice}`} <span dangerouslySetInnerHTML={{__html:currency}}/></div> */}
                </div>
                <div className='tile-content__description' dangerouslySetInnerHTML={{ __html: description }} />
                <div className='tile-content__more'>
                <a id="learnMoreHref" onClick={(event)=>{
                    event.stopPropagation();
                }} className='tile-content__more-learn' href={pUrl} target="_blank" rel="noopener noreferrer">
                    {                          
                        // <div className='tile-content__more-learn'>learn more</div>
                        <div className='tile-content__more-learn'>{t("editor.learn_more")}</div>
                    }                                       
                </a>
                    <button className='tile-content__more-select'>{t("editor.select")}</button>
                </div>
            </div>
            {/* <div className='special-price' dangerouslySetInnerHTML={{ __html: specialPrice }} /> */}
            {/* <div className={`${specialPrice?.includes("<del") ? 'special-price' : 'normal-price'}`}>{`${adjustedPrice}`} <span dangerouslySetInnerHTML={{ __html: currency }} /></div> */}
            <div className={`${price<adjustedPrice ? 'special-price' : 'normal-price'}`}>{`${price}`} <span dangerouslySetInnerHTML={{ __html: currency }} /></div>
        </div>
    )
}